import React from 'react';
import {getPermissions} from '../../../actions/userSlice';
import {
    copyQuery as copyQueryAction,
    deleteQuery, selectCurrent,
} from '../../../containers/CohortBuilder/cohortBuilderSlice';
import {canEditQuery} from '../../../containers/CohortBuilder/PermissionsUtil';
import {Query} from '../../../containers/HealthcareUsageReport/types/CohortQuery';
import {useAppDispatch, useAppSelector} from '../../../hooks';
import {generatePath, match as Match, useHistory, useRouteMatch} from "react-router-dom";
import {History} from "history";
import {buildStudyCohortRoute, extractIntParam, Routes} from "../../../pages/routes";
import {AppDispatch} from "../../../configureStore";
import styles from './EditFunctions.module.scss'
import {Delete} from "../../common/actions/Delete";
import {Copy} from "../../common/actions/Copy";
import { PayloadAction } from "@reduxjs/toolkit";
import {Project} from "../../../types/Project";

const copyQuery = (queryId: number, dispatch: AppDispatch, history: History, projectMatch: Match) => {
        dispatch(copyQueryAction(queryId))
        history.push(generatePath(Routes.Project, {
            ...projectMatch.params,
            studyId: undefined,
            study: undefined,
            subpage: undefined
        }))
    }

const EditFunctions = ({ query }: { query: Query }) => {
    const projectMatch = useRouteMatch<{projectId: string, studyId: string}>(Routes.Project)
    const history = useHistory()
    const dispatch = useAppDispatch()
    const permissions = useAppSelector(getPermissions)
    const editQuery = canEditQuery(permissions)
    const projectId = extractIntParam(projectMatch?.params?.projectId)
    const studyId = extractIntParam(projectMatch?.params?.studyId)
    const project = useAppSelector(selectCurrent).study
    const studies = project.queries

    if (!editQuery) {
        return null;
    }

    return <>
            <Copy
                className={styles.text}
                tooltip={"copy query"}
                onCopy={() => copyQuery(query.id, dispatch, history, projectMatch)}
            />
            {(studies.length ?? 0) <= 1 ? null :
                <Delete
                    text={"Delete"}
                    icon={"m"}
                    className={styles.text}
                    tooltip={"delete query"}
                    onDelete={() => dispatch(deleteQuery(query.id))
                        .then((res: PayloadAction<Project[]>) => {
                            if (query.id !== studyId || projectId === undefined) {
                                return
                            }
                            const projects = res.payload
                            const project = projects.find(project => project.id === projectId)
                            const previousStudyId = project?.queries?.[0]?.id
                            history.push(buildStudyCohortRoute(projectId, previousStudyId))
                        })
                    }
                />
            }
    </>
}

export default EditFunctions;